'use client';

import { chunkCarouselItem } from '@next-app/utils/PDPHelper';
import { CarouselProducts } from '@next-app/interface/PDP/PDPRecentlyViewedProducts';
import PDPCarouselItem from '../PDPCarousels/PDPCarouselItem';
import { PDPProductRecommendations } from '@next-app/interface/PDP/PDPProductRecommendations';

const RecommendedProducts = ({
  item,
  id,
}: {
  item: PDPProductRecommendations;
  id: string;
}) => {
  const {
    products: recommendations = [],
    recommendationTitle = '',
    mboxid = '',
    fallbackRecs = false,
  } = item || {};
  const chunkedRecommendations: CarouselProducts[][] = chunkCarouselItem(
    recommendations ?? [],
    4,
  );

  return (
    <>
      <PDPCarouselItem
        carouselId={id}
        recommendationTitle={recommendationTitle}
        chunkedRecommendations={chunkedRecommendations}
        mboxid={mboxid}
        fallbackRecs={fallbackRecs}
      />
    </>
  );
};

export default RecommendedProducts;
